import { render, staticRenderFns } from "./lkuKoranArea.vue?vue&type=template&id=071b8e36"
import script from "./lkuKoranArea.vue?vue&type=script&lang=js"
export * from "./lkuKoranArea.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranArea.vue?vue&type=style&index=0&id=071b8e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports